import React from 'react'
import TiffinManagementSystem from '../Componet/tiffin_rec';
import AdminNavbar from '../Componet/AdminNavbar';
import Footer from '../Componet/Footer';


function CalculateA() {
  return (
    <div>
        <AdminNavbar/>
    <TiffinManagementSystem/>
    <Footer/>
    </div>
  )
}

export default CalculateA
